import { render, staticRenderFns } from "./distributor.vue?vue&type=template&id=0c3a8128&scoped=true"
import script from "./distributor.vue?vue&type=script&lang=js"
export * from "./distributor.vue?vue&type=script&lang=js"
import style0 from "./distributor.vue?vue&type=style&index=0&id=0c3a8128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3a8128",
  null
  
)

export default component.exports